import dayjs from 'dayjs';
import { anyPass, cond, identity, isNil, keys, lensPath, map, reduce, reject, set, T } from 'ramda';
export const getObjectWithoutProperties = (obj, ...props) => {
    const objCopy = { ...obj };
    for (let i = 0; i < props.length; i++) {
        delete objCopy[props[i]];
    }
    return objCopy;
};
export const capitalizeObjectKeys = (obj) => {
    const entries = Object.entries(obj);
    const capsEntries = entries.map((entry) => [entry[0][0].toUpperCase() + entry[0].slice(1), entry[1]]);
    return Object.fromEntries(capsEntries);
};
export const capitalizeObjectKeysRecursively = (obj) => {
    const entries = Object.entries(obj);
    const capsEntries = entries.map((entry) => {
        const key = entry[0][0].toUpperCase() + entry[0].slice(1);
        const value = entry[1]?.constructor?.name === 'Object'
            ? capitalizeObjectKeysRecursively(entry[1])
            : entry[1];
        return [key, value];
    });
    return Object.fromEntries(capsEntries);
};
export const decapitalizeObjectKeysRecursively = (obj) => reduce((acc, key) => {
    const [first, ...other] = key;
    const newKey = `${first.toLowerCase()}${other.join('')}`;
    const newVal = cond([
        [isArrayOfObjects, map(decapitalizeObjectKeysRecursively)],
        [isObject, decapitalizeObjectKeysRecursively],
        [T, identity]
    ])(obj[key]);
    return set(lensPath([newKey]), newVal, acc);
}, {}, keys(obj));
export const decapitalizeObject = (obj) => reduce((acc, key) => {
    const [first, ...other] = key;
    const newKey = `${first.toLowerCase()}${other.join('')}`;
    acc[newKey] = obj[key];
    return acc;
}, {}, keys(obj));
export const isObject = (obj) => !Array.isArray(obj) && typeof obj === 'object' && obj !== null;
export const isArrayOfObjects = (arr) => Array.isArray(arr) && arr.toString().includes('[object Object]');
const normalizeReducer = (key) => (acc, item) => {
    acc[item[key]] = item;
    return acc;
};
export const normalizeList = (key = 'id') => reduce(normalizeReducer(key), {});
export const stringifyNumbersAndArraysInObject = (payload) => {
    const processed = {};
    Object.entries(payload)
        .forEach(([key, value]) => {
        if (typeof value === 'number') {
            processed[key] = String(value);
        }
        else if (value?.constructor.name === 'Array') {
            processed[key] = value.length ? value.join(',') : '';
        }
        else {
            processed[key] = value;
        }
    });
    return processed;
};
export function getQueryStringFromObject(allProps) {
    let props = reject(anyPass([isNil]))(allProps);
    if (props === {}) {
        const today = dayjs().format('YYYY-MM-DD');
        props = {
            period: `${today},${today}`,
            currentDateTime: dayjs().format('YYYY-MM-DD[T]HH:mm:ss')
        };
    }
    let del = '?';
    return Object.keys(props).map((key, i) => {
        if (i > 0) {
            del = '&';
        }
        return `${del}${key}=${props[key]}`;
    }).join('');
}
export const objectToQueryString = (object = {}, encode = true) => {
    if (!Object.keys(object).length)
        return '';
    const obj = reject(anyPass([isNil]))(object);
    const str = [];
    Object.keys(obj).forEach((p) => {
        const key = encode ? encodeURIComponent(p) : p;
        const value = encode ? encodeURIComponent(obj[p]) : obj[p];
        str.push(`${key}=${value}`);
    });
    return `?${str.join('&')}`;
};
export const nestedArraysToStrings = (obj) => {
    Object.keys(obj).map((key) => {
        if (Array.isArray(obj[key])) {
            obj[key] = obj[key].join(',');
        }
        return '';
    });
    return obj;
};
export const clone = (obj) => JSON.parse(JSON.stringify(obj));
export const updateRequestBodyToNumberArrays = (obj) => Object.entries(obj).reduce((counter, [key, value]) => ({
    ...counter,
    [key]: Array.isArray(value)
        ? value.map((item) => (!Number.isNaN(Number(item)) ? Number(item) : item))
        : value
}), {});
export const parseFromBlob = async (blob) => {
    try {
        const text = await blob.text();
        return JSON.parse(text);
    }
    catch (e) {
        return {};
    }
};
export const withoutProperties = (obj, ...props) => {
    const objCopy = { ...obj };
    for (let i = 0; i < props.length; i++) {
        delete objCopy[props[i]];
    }
    return objCopy;
};
